import { useState } from "react";
import { InputGroup, Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { ReactNode } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";

interface LoginInputFieldProps {
  label: string;
  type: string;
  name: string;
  placeholder?: string;
  icon?: ReactNode;
  containerClass?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

const LoginInputField = ({
  label,
  type,
  name,
  placeholder,
  icon,
  containerClass,
  disabled,
  readOnly,
}: LoginInputFieldProps) => {
  const { control, formState: { errors } } = useFormContext();
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  return (
    <Form.Group className={containerClass || "mb-3"}>
      <Form.Label className="form-label">{label}</Form.Label>
      <InputGroup>
        {icon && (
          <InputGroup.Text className="input-icon-wrapper">
            {icon}
          </InputGroup.Text>
        )}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Form.Control
              {...field}
              type={isPassword ? (showPassword ? "text" : "password") : type}
              placeholder={placeholder}
              className={`${errors[name] ? "is-invalid" : ""} ${readOnly ? "bg-light" : ""}`.trim()}
              autoComplete={name === "password" ? "current-password" : name}
              disabled={disabled}
              readOnly={readOnly}
            />
          )}
        />
        {isPassword && (
          <InputGroup.Text
            className="input-icon-wrapper"
            style={{ cursor: "pointer" }}
            onClick={() => setShowPassword(!showPassword)}
            role="button"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <FaRegEyeSlash size={18} />
            ) : (
              <FaRegEye size={18} />
            )}
          </InputGroup.Text>
        )}
      </InputGroup>
      {errors[name] && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {(errors[name] as any)?.message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default LoginInputField;

